import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCosmeticCatalog } from '../context/CatalogContext';
import { CosmeticVisual, ViewModeToggle } from '../components/visuals';
import { RELEASE_TAG, RELEASE_SHORT } from '../components/release/releaseCatalog';
import '../styles/release.css';
import './Catalog.css';


const TIER_LABELS = { free: 'Free', plus: 'Plus', premium: 'Premium', individual: 'Individual' };
const SLOT_LABELS = { head: 'Head', eyes: 'Eyes', neck: 'Neck', weapon: 'Weapon', back: 'Back', cape: 'Cape', feet: 'Feet', trail: 'Trail', none: 'Item' };

export default function CatalogCosmeticView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const cosmetics = useCosmeticCatalog();
  const { isAuthenticated } = useAuth();

  const item = cosmetics.find((c) => c.id === id);

  if (!item) {
    return (
      <div className="catalog-page">
        <div className="container">
          <div className="catalog-header">
            <h1>Cosmetic not found</h1>
            <p className="catalog-subtitle">We couldn't find that one. It may not have shipped yet.</p>
          </div>
          <Link to="/catalog?type=cosmetic" className="btn btn-secondary">Back to Cosmetics</Link>
        </div>
      </div>
    );
  }

  const tier = item.tier || 'individual';
  const price = item.price ?? 0;
  const isReleaseItem = item.release_tag === RELEASE_TAG;

  return (
    <div className="catalog-page">
      <div className="container">
        <div className="catalog-header" style={{ marginBottom: 16 }}>
          <Link to="/catalog?type=cosmetic" className="btn btn-ghost btn-sm">← All cosmetics</Link>
          <ViewModeToggle />
        </div>

        <div className="card detail-inner release-detail-card" style={{ maxWidth: 880, margin: '0 auto' }}>
          <div className="detail-header" style={{ alignItems: 'center', gap: 24 }}>
            <div
              className="detail-avatar-lg release-bloom"
              style={{ width: 320, height: 320, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <CosmeticVisual cosmeticId={item.id} size={260} live
                              fallback={<span style={{ color: 'var(--text-muted)' }}>Preview unavailable</span>} />
            </div>

            <div style={{ flex: 1, minWidth: 240 }}>
              <h1 style={{ marginBottom: 8 }}>{item.name}</h1>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                <span className={`tier-badge tier-${tier}`}>{TIER_LABELS[tier]}</span>
                <span className="catalog-item-slot">{SLOT_LABELS[item.slot] || item.slot}</span>
                {tier === 'individual' && (
                  <span
                    className="catalog-earnable-pill"
                    title="Available with treats. Earn treats by logging in and during events."
                  >
                    Earnable
                  </span>
                )}
                {isReleaseItem && <span className="catalog-earnable-pill">{RELEASE_SHORT}</span>}
              </div>

              {item.description && (
                <p style={{ color: 'var(--text-secondary)', marginBottom: 16 }}>{item.description}</p>
              )}

              {price > 0 ? (
                <div className="detail-locked">
                  <p className="detail-locked-msg">
                    Unlock {item.name} for <strong>{price} treats</strong>.
                  </p>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button className="btn btn-primary" onClick={() => navigate('/shop')}>
                      Earn treats
                    </button>
                    {!isAuthenticated && (
                      <Link to="/login" className="btn btn-ghost">Sign in</Link>
                    )}
                  </div>
                </div>
              ) : (
                <p style={{ color: 'var(--text-secondary)' }}>Free for everyone.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
